
import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Tabs from "./Tabs";
import Summary from "./Summary";
import { Box } from "@mui/material"; // ✅ Import Box
import ErrorDetails from "./ErrorDetails";
import RuleCatalogue from "./RuleCatalogue";
import axios from "axios";
import "./DataProduct.css";

const DataProduct = () => {
  const { productId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [dashboardId, setDashboardId] = useState(null);

  const tabFromUrl = searchParams.get("tab") || "Summary";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [pivotGrouping, setPivotGrouping] = useState({}); 
  const [toast, setToast] = useState({ message: "", type: "" });


const handleSaveFilters = async () => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const payload = {
    product_id: productId,
    filters: filters,
    search_term: searchTerm,
    pivot_grouping: pivotGrouping,
dashboard_view_name: "Product Dashboard View"
  };

  try {
    const res = await axios.post(`${BASE_URL}/save-dashboard-view`, payload);
    if (res.data?.dashboard_id) {
  setDashboardId(res.data.dashboard_id);   
}


    if (res.data?.message) {
      setToast({ message: res.data.message, type: "success" });
    } else {
      setToast({ message: "Filters saved successfully", type: "success" });
    }

    setTimeout(() => setToast({ message: "", type: "" }), 2500);
  } catch (error) {
    if (error.response?.status === 409) {
      setToast({ message: error.response.data.detail, type: "warning" });
    } else {
      setToast({ message: "Please apply a filter before saving", type: "error" });
    }

    setTimeout(() => setToast({ message: "", type: "" }), 2500);
  }
};



const handleFiltersChange = (newFilters) => {
   if (newFilters.pivot_grouping) {
    setPivotGrouping(newFilters.pivot_grouping);
    return;
  }
  if (newFilters && Object.keys(newFilters).length === 0 && newFilters.constructor === Object) {
    setFilters({});
    return;
  }

  setFilters({ ...(newFilters || {}) });
};


  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  return (
     <Box
      sx={{
        padding: 0, 
       
      }}
    >
    <div className="dashboard-dashboard poppins-regular">
   {toast.message && (
  <div
    style={{
      position: "fixed",
      top: "80px",
      left: "50%",
      transform: "translateX(-50%)",
      background:
        toast.type === "success"
          ? "#4caf50"   // green
          : toast.type === "warning"
          ? "#ff9800"   // orange/yellow
          : "#f44336",  // red
      color: "#fff",
      padding: "6px 14px",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      zIndex: 1000,
    }}
  >
    {toast.message}
  </div>
)}

      <Tabs activeTab={activeTab} setActiveTab={setActiveTab}  onSaveClick={handleSaveFilters} dashboardId={dashboardId} />

      <div className="tab-content-tab" style={{background:'#F7F7F7',padding:'28px'}}> 
        {activeTab === "Summary" && <Summary
                    key={`error-${productId}`}
                     productId={productId}
                      currentFilters={filters}
            onFiltersChange={handleFiltersChange}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}

/>}

        {activeTab === "Error Details" && (
          <ErrorDetails
            key={`error-${productId}`}
            productId={productId}
            currentFilters={filters}
            onFiltersChange={handleFiltersChange}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
          />
        )}

        {activeTab === "Rule Catalogue" && (
          <RuleCatalogue
            key={`rule-${productId}`}
            productId={productId}
            currentFilters={filters}
            onFiltersChange={handleFiltersChange}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
          />
        )}
      </div>
    </div>
    </Box>
  );
};

export default DataProduct;


